import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { validateTokenForSecurity } from "../../utils/tokenUtils";

/**
 * Custom hook for token validation across all screens
 * Automatically checks token validity and contractor_id presence
 * Returns validation state and functions to handle security modal
 */
export const useTokenValidation = () => {
  const [showSecurityModal, setShowSecurityModal] = useState(false);
  const [validationResult, setValidationResult] = useState(null);

  // Get token from Redux store
  const token = useSelector((state) => state.auth?.token);
  //   const token= "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6Imt1bmFsLmJhdHJhMThAZ21haWwuY29tIiwiaWQiOjEwMzIsInJvbGUiOiJjb250cmFjdG9yIiwibG9naW5fdG9rZW4iOiJraThWdkxZUyIsInVzZXJuYW1lIjoia3VuYWwuYmF0cmExOEBnbWFpbC5jb20iLCJpc3MiOiJyZW5vLWhvbWUuYXp1cmV3ZWJzaXRlcy5uZXQiLCJpYXQiOjE3NTYxOTIwMzAsImV4cCI6MTc4NzcyODAzMH0.2AUGjjgei_yNXF39mCgFmEtpWe8nv5uSEOB4rdjiy6Q"

  useEffect(() => {
    // console.log("🔄 [HOOK] useTokenValidation hook triggered");
    // console.log("🔍 [HOOK] Token from Redux:", token ? "Present" : "Missing");

    if (token) {
      // console.log("🔍 [HOOK] Token length:", token.length);
      // console.log("🔍 [HOOK] Starting validation...");

      const result = validateTokenForSecurity(token);
      setValidationResult(result);

      // console.log("🔍 [HOOK] Validation result:", result);
      // console.log(
      //   "🔍 [HOOK] Should show security modal:",
      //   result.shouldShowSecurityModal
      // );

      // Show security modal if needed
      if (result.shouldShowSecurityModal) {
        // console.log("🚨 [HOOK] Setting security modal to show");
        setShowSecurityModal(true);
      } else {
        // console.log("✅ [HOOK] Token is secure, no modal needed");
      }
    } else {
      // No token found, show security modal
      // console.log("❌ [HOOK] No token found in Redux store");
      // console.log("🚨 [HOOK] Setting security modal to show");

      setValidationResult({
        isValid: false,
        hasContractorId: false,
        error: "No token found",
        shouldShowSecurityModal: true,
      });
      setShowSecurityModal(true);
    }
  }, [token]);

  const handleSecurityModalClose = () => {
    // console.log("🔒 [HOOK] Security modal close handler called");
    setShowSecurityModal(false);
  };

  // Token is valid if it's valid AND either has contractor_id OR has contractor-related role
  // This allows contractor_project_manager and other contractor roles to pass validation
  const isTokenValid =
    validationResult?.isValid && 
    (validationResult?.hasContractorId || validationResult?.hasContractorRole);

  return {
    token,
    validationResult,
    showSecurityModal,
    setShowSecurityModal,
    handleSecurityModalClose,
    isTokenValid,
    shouldShowSecurityModal: validationResult?.shouldShowSecurityModal || false,
  };
};
